module.exports = __webpack_public_path__ + "img/disners.2f188dbb.jpg";